import { useTheme as useThemeFromProvider } from '@/components/providers/ThemeProvider';

export const useTheme = useThemeFromProvider;
export type { Theme } from '@/components/providers/ThemeProvider';